/**
 * Category Icon Library
 * Centralized icon definitions for categories, brands, and product groups
 * Usage: import { CATEGORY_ICONS, getCategoryIcon } from './CategoryIcons'
 */

import React from 'react';

export const CATEGORY_ICONS = {
  tobacco: {
    label: 'Tobacco / Vape',
    svg: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="6" cy="12" r="2"/>
        <circle cx="18" cy="12" r="2"/>
        <path d="M8 12h8M4 8v8M20 8v8"/>
      </svg>
    )
  },
  drink: {
    label: 'Beverages / Drinks',
    svg: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M7 3h10l-1 8H8z"/>
        <rect x="6" y="11" width="12" height="10" rx="1"/>
        <path d="M9 16h6"/>
      </svg>
    )
  },
  snack: {
    label: 'Snacks / Crisps',
    svg: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <rect x="4" y="6" width="16" height="13" rx="2"/>
        <path d="M4 10h16M8 6v4M12 6v4M16 6v4"/>
      </svg>
    )
  },
  candy: {
    label: 'Candy / Sweets',
    svg: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="8"/>
        <path d="M12 8v8M8 12h8"/>
        <circle cx="12" cy="12" r="3"/>
      </svg>
    )
  },
  alcohol: {
    label: 'Alcohol / Beer / Wine',
    svg: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M8 2h8l-2 8H10z"/>
        <path d="M7 10h10v9a2 2 0 01-2 2H9a2 2 0 01-2-2z"/>
        <path d="M9 14h6"/>
      </svg>
    )
  },
  food: {
    label: 'Food / Meals',
    svg: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 12h16M6 8h12a2 2 0 012 2v6a2 2 0 01-2 2H6a2 2 0 01-2-2v-6a2 2 0 012-2z"/>
        <path d="M8 12v4M16 12v4"/>
      </svg>
    )
  },
  bakery: {
    label: 'Bakery / Bread',
    svg: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <ellipse cx="12" cy="14" rx="8" ry="6"/>
        <path d="M6 14c0-2 2-4 6-4s6 2 6 4"/>
        <path d="M9 11l1-3M15 11l-1-3M12 8v3"/>
      </svg>
    )
  },
  dairy: {
    label: 'Dairy / Milk',
    svg: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <rect x="7" y="4" width="10" height="16" rx="1"/>
        <path d="M7 8h10M10 4V2M14 4V2"/>
      </svg>
    )
  },
  frozen: {
    label: 'Frozen',
    svg: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 3v18M6 6l12 12M6 18L18 6M3 12h18"/>
        <circle cx="12" cy="12" r="2"/>
      </svg>
    )
  },
  household: {
    label: 'Household / Cleaning',
    svg: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 21h18M5 21V9l7-6 7 6v12"/>
        <rect x="9" y="13" width="6" height="5"/>
      </svg>
    )
  },
  health: {
    label: 'Health / Beauty',
    svg: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="8" r="4"/>
        <path d="M6 21v-2a4 4 0 014-4h4a4 4 0 014 4v2"/>
      </svg>
    )
  },
  pet: {
    label: 'Pet Supplies',
    svg: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <ellipse cx="12" cy="14" rx="5" ry="4"/>
        <circle cx="8" cy="8" r="2"/>
        <circle cx="16" cy="8" r="2"/>
        <circle cx="6" cy="12" r="1.5"/>
        <circle cx="18" cy="12" r="1.5"/>
      </svg>
    )
  },
  baby: {
    label: 'Baby Products',
    svg: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="8" r="4"/>
        <path d="M8 16c0-2 1.8-4 4-4s4 2 4 4v5H8z"/>
        <path d="M10 21v-3M14 21v-3"/>
      </svg>
    )
  },
  default: {
    label: 'General',
    svg: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <rect x="4" y="4" width="16" height="16" rx="2"/>
        <path d="M4 9h16M9 4v16"/>
      </svg>
    )
  }
};

/**
 * Get icon for a category by icon_name or auto-detect from name
 * @param {string|null} iconName - The icon_name from database
 * @param {string} categoryName - Category name for auto-detection fallback
 * @returns {JSX.Element} SVG icon element
 */
export function getCategoryIcon(iconName, categoryName = '') {
  // If icon_name is provided and exists, use it
  if (iconName && CATEGORY_ICONS[iconName]) {
    return CATEGORY_ICONS[iconName].svg;
  }
  
  // Fallback: Auto-detect from category name
  const name = categoryName.toLowerCase();
  
  if (name.includes('tobacco') || name.includes('cigarette') || name.includes('vape')) {
    return CATEGORY_ICONS.tobacco.svg;
  } else if (name.includes('drink') || name.includes('beverage') || name.includes('water') || name.includes('juice')) {
    return CATEGORY_ICONS.drink.svg;
  } else if (name.includes('snack') || name.includes('crisp') || name.includes('chip')) {
    return CATEGORY_ICONS.snack.svg;
  } else if (name.includes('candy') || name.includes('sweet') || name.includes('chocolate')) {
    return CATEGORY_ICONS.candy.svg;
  } else if (name.includes('alcohol') || name.includes('beer') || name.includes('wine') || name.includes('spirit')) {
    return CATEGORY_ICONS.alcohol.svg;
  } else if (name.includes('food') || name.includes('meal') || name.includes('sandwich')) {
    return CATEGORY_ICONS.food.svg;
  } else if (name.includes('bakery') || name.includes('bread') || name.includes('pastry')) {
    return CATEGORY_ICONS.bakery.svg;
  } else if (name.includes('dairy') || name.includes('milk') || name.includes('cheese')) {
    return CATEGORY_ICONS.dairy.svg;
  } else if (name.includes('frozen')) {
    return CATEGORY_ICONS.frozen.svg;
  } else if (name.includes('household') || name.includes('cleaning')) {
    return CATEGORY_ICONS.household.svg;
  } else if (name.includes('health') || name.includes('beauty') || name.includes('cosmetic')) {
    return CATEGORY_ICONS.health.svg;
  } else if (name.includes('pet')) {
    return CATEGORY_ICONS.pet.svg;
  } else if (name.includes('baby')) {
    return CATEGORY_ICONS.baby.svg;
  }
  
  return CATEGORY_ICONS.default.svg;
}

/**
 * Get all available icon options for dropdown/picker
 * @returns {Array<{key: string, label: string, svg: JSX.Element}>}
 */
export function getAllIconOptions() {
  return Object.entries(CATEGORY_ICONS).map(([key, { label, svg }]) => ({
    key,
    label,
    svg
  }));
}
